import React, {useEffect, useState} from 'react'
import {
	DBFilterDateArea,
	DBFilterWrapper,
	DBTableExcelBtn,
	DateArea,
	GotoStatus,
} from '../DB/styles'
import { Select, Input, ConfigProvider, DatePicker, Upload, message } from 'antd'
import { RangePickerProps } from 'rc-picker/es/RangePicker.d'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import locale from 'antd/lib/locale/ko_KR'
import { Icon } from '../Main/styles'
import { IoSearch } from 'react-icons/io5'
import { FaRegFileExcel } from 'react-icons/fa6'
import { useMyInfo } from '../../hooks/GetMyInfo'
import API from '../../../utils/api'
import { useToken } from '../../../app/hooks'
import {useIsMobile} from "../../components/IsMobile";

const { RangePicker } = DatePicker

export const BranchFilter = ({
	resList,
	teamList,
	branchList,
	name,
	setName,
	respon,
	setRespon,
	team,
	setTeam,
	branch,
	setBranch,
	address,
	setAddress,
	depositAt,
	setDepositAt,
	withdrawAt,
	setWithdrawAt, bList
}) => {
	const IsMobile = useIsMobile()
	useEffect(() => {
		setInputName(name)
		setInputAddress(address)
		setInputRes(respon)
		setInputTeam(team)
		setInputBranch(branch)
		setInputDeposit([depositAt?.[0], depositAt?.[1]])
		setInputWithdraw([withdrawAt?.[0], withdrawAt?.[1]])

	}, [name, address, respon, team, branch, depositAt, withdrawAt])
	const [inputName, setInputName] = useState(name)
	const [inputRes, setInputRes] = useState(respon)
	const [inputTeam, setInputTeam] = useState(team)
	const [inputBranch, setInputBranch] = useState(branch)
	const [upload, setUpload] = useState<any>('')
	const [inputAddress, setInputAddress] = useState(address)
	const [inputDeposit, setInputDeposit] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([
		null,
		null,
	])
	const [inputWithdraw, setInputWithdraw] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([
		null,
		null,
	])

	const { myInfo } = useMyInfo()
	const { data: token } = useToken()


	const clickSearch = () => {
		const depositedStart = inputDeposit?.[0] ? dayjs(inputDeposit?.[0]) : null;
		const depositedEnd = inputDeposit?.[1] ? dayjs(inputDeposit?.[1]) : null;

		const withdrawStart = inputWithdraw?.[0] ? dayjs(inputWithdraw?.[0]) : null;
		const withdrawdEnd = inputWithdraw?.[1] ? dayjs(inputWithdraw?.[1]) : null;

		setDepositAt([depositedStart, depositedEnd]);
		setWithdrawAt([withdrawStart, withdrawdEnd])
		setName(inputName)
		setRespon(inputRes)
		setTeam(inputTeam)
		setBranch(inputBranch)
		setAddress(inputAddress)

	}


	return (
		<>
			{IsMobile ?
				<DBFilterWrapper style={{marginBottom: 20}}>
					<DBFilterDateArea>
						<DateArea>
							<label htmlFor="name">담당자</label>
							<Select value={inputRes} onChange={e => setInputRes(e)} style={{width: '150px'}}>
								<option style={{ fontFamily: 'Pretendard' }} value={''}>
									--
								</option>
								{resList?.map(it => (
									<option style={{ fontFamily: 'Pretendard' }} value={it.name}>
										{it.name}
									</option>
								))}
							</Select>
						</DateArea>
					</DBFilterDateArea>

						<DBFilterDateArea>
							<DateArea>
								<label htmlFor="name">팀별</label>
								<Select value={inputTeam} onChange={e => setInputTeam(e)}>
									<option style={{ fontFamily: 'Pretendard' }} value={''}>
										--
									</option>
									{teamList?.map(it => (
										<option style={{ fontFamily: 'Pretendard' }} value={it.name}>
											{it.name}
										</option>
									))}
								</Select>
							</DateArea>
						</DBFilterDateArea>

						<DBFilterDateArea>
							<DateArea>
								<label htmlFor="name">지사명</label>
								<Select value={inputBranch} onChange={e => setInputBranch(e)}>
									<option style={{ fontFamily: 'Pretendard' }} value={''}>
										--
									</option>
									{bList?.map(it => (
										<option style={{ fontFamily: 'Pretendard' }} value={it.id}>
											{it.name}
										</option>
									))}
								</Select>
							</DateArea>
						</DBFilterDateArea>

						<DBFilterDateArea>
							<DateArea>
								<label htmlFor="tel">입금자명</label>
								<Input
									type="text"
									id="tel"
									value={inputName}
									onChange={e => setInputName(e.target.value)}
									placeholder="입금자명 검색 입력"
								/>
							</DateArea>
						</DBFilterDateArea>

						<DBFilterDateArea>
							<DateArea>
								<label htmlFor="tel">간편주소</label>
								<Input
									type="text"
									id="tel"
									value={inputAddress}
									onChange={e => setInputAddress(e.target.value)}
									placeholder="주소 검색 입력"
								/>
							</DateArea>
						</DBFilterDateArea>



					<DBFilterDateArea>
							<DateArea>
								<label htmlFor="createdAt">입금일</label>
								<ConfigProvider locale={locale}>
									<RangePicker
										id="createdAt"
										value={inputDeposit}
										onChange={values => setInputDeposit(values)}
									/>
								</ConfigProvider>
							</DateArea>
						</DBFilterDateArea>

					<DBFilterDateArea>
						<DateArea>
							<label htmlFor="createdAt">출금일</label>
							<ConfigProvider locale={locale}>
								<RangePicker
									id="createdAt"
									value={inputWithdraw}
									onChange={values => setInputWithdraw(values)}
								/>
							</ConfigProvider>
						</DateArea>
					</DBFilterDateArea>

					<DBFilterDateArea>
						<GotoStatus onClick={clickSearch} style={{ backgroundColor: '#26DAD1' }}>
							<Icon>
								<IoSearch />
							</Icon>
							검색
						</GotoStatus>
					</DBFilterDateArea>

					<DBFilterDateArea>
						{myInfo.master && (
							<>
								<Upload
									onChange={(fileList: any) => {
										setUpload(fileList)
									}}>
									파일선택
								</Upload>
								<DBTableExcelBtn
									onClick={() => {

										if (upload?.fileList === undefined) {
											message.error('파일을 선택해주세요')
											return
										}

										const targetFilesArrayLogo = Array.from(upload.fileList)
										const formData = new FormData()


										if (upload?.fileList?.length === 0) {
											message.error('파일을 선택해주세요')
											return
										}

										targetFilesArrayLogo.forEach((file: any) => {
											if (file.originFileObj) {
												formData.append('file', file.originFileObj)
											}
										})

										API.postImage('POST', '/branch/list', token + '', formData)
											.then((res: any) => {
												if (res.result.success) {
													message.success('수정되었습니다')
												} else {
													message.error('파일이 잘못되었습니다')
												}
											})
											.catch((err: any) => {})
									}}
									style={{ backgroundColor: '#437eff', color: '#fff' }}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									엑셀등록
								</DBTableExcelBtn>
							</>
						)}
					</DBFilterDateArea>

				</DBFilterWrapper>
				:
				<DBFilterWrapper>
					<DBFilterDateArea>
						<DateArea>
							<label htmlFor="name">담당자</label>
							<Select value={inputRes} onChange={e => setInputRes(e)} style={{width: '150px'}}>
								<option style={{ fontFamily: 'Pretendard' }} value={''}>
									--
								</option>
								{resList?.map(it => (
									<option style={{ fontFamily: 'Pretendard' }} value={it.name}>
										{it.name}
									</option>
								))}
							</Select>
						</DateArea>
						<DateArea>
							<label htmlFor="name">팀별</label>
							<Select value={inputTeam} onChange={e => setInputTeam(e)}>
								<option style={{ fontFamily: 'Pretendard' }} value={''}>
									--
								</option>
								{teamList?.map(it => (
									<option style={{ fontFamily: 'Pretendard' }} value={it.name}>
										{it.name}
									</option>
								))}
							</Select>
						</DateArea>
						<DateArea>
							<label htmlFor="name">지사명</label>
							<Select value={inputBranch} onChange={e => setInputBranch(e)}>
								<option style={{ fontFamily: 'Pretendard' }} value={''}>
									--
								</option>
								{bList?.map(it => (
									<option style={{ fontFamily: 'Pretendard' }} value={it.id}>
										{it.name}
									</option>
								))}
							</Select>
						</DateArea>
						<DateArea>
							<label htmlFor="tel">입금자명</label>
							<Input
								type="text"
								id="tel"
								value={inputName}
								onChange={e => setInputName(e.target.value)}
								placeholder="입금자명 검색 입력"
							/>
						</DateArea>
						<DateArea>
							<label htmlFor="tel">간편주소</label>
							<Input
								type="text"
								id="tel"
								value={inputAddress}
								onChange={e => setInputAddress(e.target.value)}
								placeholder="주소 검색 입력"
							/>
						</DateArea>
					</DBFilterDateArea>
					<DBFilterDateArea>
						<>
							<DateArea>
								<label htmlFor="createdAt">입금일</label>
								<ConfigProvider locale={locale}>
									<RangePicker
										id="createdAt"
										value={inputDeposit}
										onChange={values => setInputDeposit(values)}
									/>
								</ConfigProvider>
							</DateArea>
							<DateArea>
								<label htmlFor="createdAt">출금일</label>
								<ConfigProvider locale={locale}>
									<RangePicker
										id="createdAt"
										value={inputWithdraw}
										onChange={values => setInputWithdraw(values)}
									/>
								</ConfigProvider>
							</DateArea>
						</>

						<GotoStatus onClick={clickSearch} style={{ backgroundColor: '#26DAD1' }}>
							<Icon>
								<IoSearch />
							</Icon>
							검색
						</GotoStatus>

						{myInfo.master && (
							<>
								<Upload
									onChange={(fileList: any) => {
										setUpload(fileList)
									}}>
									파일선택
								</Upload>
								<DBTableExcelBtn
									onClick={() => {

										if (upload?.fileList === undefined) {
											message.error('파일을 선택해주세요')
											return
										}

										const targetFilesArrayLogo = Array.from(upload.fileList)
										const formData = new FormData()


										if (upload?.fileList?.length === 0) {
											message.error('파일을 선택해주세요')
											return
										}

										targetFilesArrayLogo.forEach((file: any) => {
											if (file.originFileObj) {
												formData.append('file', file.originFileObj)
											}
										})

										API.postImage('POST', '/branch/list', token + '', formData)
											.then((res: any) => {
												if (res.result.success) {
													message.success('수정되었습니다')
												} else {
													message.error('파일이 잘못되었습니다')
												}
											})
											.catch((err: any) => {})
									}}
									style={{ backgroundColor: '#437eff', color: '#fff' }}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									엑셀등록
								</DBTableExcelBtn>
							</>
						)}
					</DBFilterDateArea>
				</DBFilterWrapper>
			}
		</>
	)
}

export default React.memo(BranchFilter)
